import { useCallback, useEffect } from 'react';
import { useAtomCallback } from 'jotai/utils';
import { networkStatusAtom } from '@/atoms/networkStatus/networkStatusAtoms';
import { useConfig } from '@/contexts/ConfigContext';

// Listen for postMessage events coming from the embedded "client" iframe and
// update our global networkStatusAtom accordingly. This decouples the
// standalone shell from the child frame – the child just needs to send
// `{ source: 'antimatter-client', networkStatus: 'online' | 'offline' }`.
export function useClientFrameNetworkErrorListener() {
  const { IFRAME_URL } = useConfig();

  const handleMessage = useAtomCallback(
    useCallback(
      (_, set, event: MessageEvent) => {
        if (event.origin !== IFRAME_URL) {
          return;
        }

        if (event?.data?.source !== 'antimatter-client') {
          return;
        }

        if (event?.data?.networkStatus) {
          set(networkStatusAtom, event.data.networkStatus);
        }
      },
      [IFRAME_URL],
    ),
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [IFRAME_URL, handleMessage]);
}
